import { Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ClBaseComponent } from '../cl-base/cl-base.component';
import { Checklist, ChecklistTemplate } from 'src/app/components/checklists/checklists';
import { ImageTablePopupComponent, } from './image-table-popup/image-table-popup.component';
import { RadTableConfiguration } from './cl-image-upload-content/cl-image-upload-content.component';
import { MatDialogRef } from '@angular/material/dialog';
import { SaveTaskResource } from 'src/app/components/workflow/workflow';
import { ChecklistsService } from 'src/app/components/checklists/checklists.service';
import { WFSaveOptions } from 'src/app/common/enumerations/enumerations';


export class TableColumn {
  name!: string;
  label?: string;
  readOnly?: boolean;
  editor?: any;
  type?: string;
  numericFormat?: any;
  source?: any;
  renderer?: any;
  className?: string;
  width?: number;
  span?: number;
  include?: boolean;
}

export class TableData {
  id!: number;
  values!: string;
  rowId!: string;
  spotid!: number;
  imageid!: number;
  idSpan?: number;
}

@Component({
  selector: 'cl-image-upload',
  templateUrl: './cl-image-upload.component.html',
  styleUrls: ['./cl-image-upload.component.scss']
})
export class ClImageUploadComponent extends ClBaseComponent implements OnInit, OnChanges, OnDestroy {

  @Input() enableColumnsBuilder!: boolean;
  @Input() enableColumnsChecklist!: boolean;
  @Input() checklistTemplate?: ChecklistTemplate;

  radTableConfiguration?: RadTableConfiguration;
  currentChecklist?: Checklist;

  constructor(
    protected override injector: Injector,
    private service: ChecklistsService
  ) {
    super(injector);
  }
  ngOnInit(): void {
    this.radTableConfiguration = this.utils.JSONparse(this.configuration) as RadTableConfiguration;
    this.currentChecklist = this.checklist as Checklist;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['configuration'] && this.configuration) {
      this.radTableConfiguration = this.utils.JSONparse(this.configuration) as RadTableConfiguration;
    }
  }

  private dialogRef?: MatDialogRef<ImageTablePopupComponent>;

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  openPopup(): void {
    this.dialogRef = this.dialog.open(ImageTablePopupComponent, {
      panelClass: 'window-dialog',
      width: '99vw',
      height: '99vh',
      autoFocus: false,
      disableClose: true,
      data: {
        title: (this.signature?.wfTaskLocal?.wfStepLocal?.wfSectionLocal.name && this.signature?.wfTaskLocal?.wfStepLocal?.name)
          ? `${this.signature.wfTaskLocal.wfStepLocal.wfSectionLocal.name} - ${this.signature.wfTaskLocal.wfStepLocal.name}`
          : (this.label ?? ''),
        date: this.date,
        disabled: this.disabled,
        signature: this.signature,
        taskID: this.taskID ?? 0,
        checklist: this.checklist,
        number: this.number,
        roleIds: this.roleIds,
        checklistTemplate: this.checklistTemplate,
        configuration: this.radTableConfiguration,
        editor: this.editor ?? false,
        builder: this.builder ?? false,
        enableColumnsBuilder: this.enableColumnsBuilder,
      }
    });

    const saveSub = this.dialogRef.componentInstance.saveConfiguration.subscribe((data: any) => {
      this.radTableConfiguration = { ...data };
      const configurationString = this.utils.JSONstringify(data);
      this.saveConfiguration(configurationString);
    });

    this.dialogRef.afterClosed().subscribe(() => {
      saveSub.unsubscribe();
      this.dialogRef = undefined;
    });
  }

  saveConfiguration(configurationString: string) {
    if (this.taskID && !this.builder && !this.editor) {
      // Checklist execution: persist directly via the task save API
      const saveTaskResource = {
        id: this.taskID,
        text: configurationString,
        field: "text",
        option: WFSaveOptions.MANUAL,
      } as SaveTaskResource;

      this.service.saveWFTask(saveTaskResource, false).subscribe(() => {
        this.setFormDirty(false);
      });
    } else {
      // Builder/editor mode: propagate config up via save event so cl-editor updates
      this.save.emit(configurationString);
      this.setFormDirty(false);
    }
  }


}
